module.exports = __webpack_public_path__ + "8a1c9c821026aef71017c011102ccf6e.png";